<template>
  <pt-customer-detail @unbindWx="unbindWx" @registryCps="registryCps" class="pt-customer-detail__withData" :userDetail="userDetail" :wxDetail="wxDetail" :id="id" :loading="loading" :levelDetail="levelDetail"
  @userTabPage="userTabPage" :shippingAddresses="shippingAddresses" :walletDetail="walletDetail" @mallUserDetail="mallUserDetail"></pt-customer-detail>
</template>

<script>
import PtCustomerDetail from './index'
export default {
  name: 'pt-customer-detail__withData',
  components: {
    'pt-customer-detail': PtCustomerDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      userDetail: {},
      userDetailLoading: false,
      shippingAddresses: [],
      walletDetail: {},
      levelDetail: {},
      wxDetail: {}
    }
  },
  computed: {
    loading () {
      return this.userDetailLoading
    }
  },
  watch: {
    id (val) {
      this.mallUserDetail()
    }
  },
  methods: {
    // 用户信息tab的接口请求
    userTabPage () {
      this.mallUserDetail()
    },
    mallUserDetail () {
      this.userDetailLoading = true
      this.$store.dispatch('getUserDetailAddress', this.id).then(res => {
        this.userDetailLoading = false
        this.customerMemberLevelInfo(res.userLogin)
        this.getUserWxInfo(res.userLogin)
        this.userDetail = res
        this.shippingAddresses = res.shippingAddresses || []
      }).catch(err => {
        this.userDetailLoading = false
        this.$message.error(err || '获取用户详情失败')
      })
    },
    customerMemberLevelInfo (userLogin) {
      this.userDetailLoading = true
      this.$store.dispatch('customerMemberLevelInfo', userLogin).then(res => {
        this.levelDetail = res
        this.userDetailLoading = false
      }).catch(err => {
        this.userDetailLoading = false
        this.$message.error(err || '获取用户会员信息失败')
      })
    },
    getUserWxInfo (userLogin) {
      this.userDetailLoading = true
      this.$store.dispatch('getUserWxInfo', userLogin).then(res => {
        this.wxDetail = res
        this.userDetailLoading = false
      }).catch(err => {
        this.userDetailLoading = false
        this.$message.error(err || '获取用户微信信息失败')
      })
    },
    unbindWx (val) {
      this.$confirm('您确定解绑该用户微信吗', '微信解绑', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        this.$store.dispatch('unbindWx', val).then(response => {
          this.$message.success('微信解绑成功')
          this.mallUserDetail()
        }).catch(err => {
          this.$message.error(err || '微信解绑失败')
        })
      }).catch(_ => {})
    },
    registryCps () {
      this.$confirm('您确定将该用户信息重新注册到CPS吗？', '重新注册CPS', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        this.$store.dispatch('registryCpsUser', this.userDetail.userLogin).then(response => {
          this.$message.success('注册成功')
          this.mallUserDetail()
        }).catch(err => {
          this.$message.error(err || '注册失败')
        })
      }).catch(_ => {})
    }
  },
  created () {
    this.mallUserDetail()
  }
}
</script>
